import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getLatestValidStepIndex } from '../../utils/store/getLatestValidStepIndex';
import { FC, ReactElement } from 'react';
import { getRoutes } from '../../utils/router/getRoutes';

export const FormGuard: FC = (): ReactElement => {
  const location = useLocation();
  const latestValidIndex = getLatestValidStepIndex();
  const { formStepRoutes } = getRoutes();
  const currentStepIndex = formStepRoutes.findIndex((step) => step.path === location.pathname);
  const params = new URLSearchParams(window.location.search);

  if (params.get('mn') && (currentStepIndex < latestValidIndex || location.pathname === '/')) {
    return <Navigate to={formStepRoutes[latestValidIndex].path} replace />;
  }

  if (currentStepIndex === -1 || currentStepIndex > latestValidIndex) {
    return <Navigate to={formStepRoutes[latestValidIndex].path} replace />;
  }

  return <Outlet />;
};
